import { MantineThemeOverride } from '@mantine/core';

export type TitleTheme = NonNullable<MantineThemeOverride['components']>['Title'];

export const Title: TitleTheme = {
  // todo: define
};
